import { GET_DUPLICATE_CHECK,GET_DUPLICATE_FIELD_WEIGHTAGE} from '../types'

const INITIAL_STATE = {
  allDuplicate: [],
  allFieldWeightage:[]
}

const duplicateReducer = (state = INITIAL_STATE, { type, payload }) => {

  switch (type) {
    case GET_DUPLICATE_CHECK:
      return {
        ...state,
        allDuplicate: payload.data,
      }
      case GET_DUPLICATE_FIELD_WEIGHTAGE:
        return {
          ...state,
          allFieldWeightage: payload.data,
        }
    default:
      return state
  }
}

export default duplicateReducer
